// Why the local database could not open, sorted for the words on the error screen
// (docs/plans/local-db-pools.md). Shared by the worker, which puts the kind in front of its
// message, and the app, which reads it back.

/** Why the local database could not open, for the words on the error screen. */
export type OpenErrorKind = 'busy' | 'full' | 'unsupported' | 'other'

/** Sorts an open failure; the worker puts the kind in front of its message ("busy: …"). */
export function openErrorKind(error: unknown): OpenErrorKind {
  const name = error instanceof Error ? error.name : ''
  const message = error instanceof Error ? error.message : String(error)
  const tagged = /^(busy|full|unsupported|other): /.exec(message)
  if (tagged) return tagged[1] as OpenErrorKind
  if (
    name === 'NoModificationAllowedError' ||
    /Access Handles? cannot be created|another open Access Handle|NoModificationAllowed/i.test(
      message,
    )
  )
    return 'busy'
  if (name === 'QuotaExceededError' || /quota|no space|SQLITE_FULL/i.test(message)) return 'full'
  if (
    /createSyncAccessHandle is not|getDirectory is not|not supported|SecurityError/i.test(message)
  )
    return 'unsupported'
  return 'other'
}

/** The message with its kind in front, as the worker sends it. */
export const taggedOpenError = (error: unknown): Error => {
  const message = error instanceof Error ? error.message : String(error)
  const kind = openErrorKind(error)
  return new Error(message.startsWith(`${kind}: `) ? message : `${kind}: ${message}`)
}

/** The message without its kind, for showing under the plain words. */
export const untaggedMessage = (message: string): string =>
  message.replace(/^(busy|full|unsupported|other): /, '')
